var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveIiHandGiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "love-it-hand-give"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0.75 14.25V23.25",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M0.75 21.75H15.75C15.75 20.0931 14.4069 18.75 12.75 18.75H9C9 17.0931 7.65685 15.75 6 15.75H0.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M6 18.75H9",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7497 13.8748L9.35767 7.20679C8.20709 6.05532 7.92158 4.29717 8.64867 2.84079V2.84079C9.19233 1.75342 10.2256 0.993686 11.4256 0.798936C12.6256 0.604186 13.846 0.998163 14.7057 1.85779L15.7497 2.89979L16.7937 1.85579C17.6533 0.996163 18.8738 0.602186 20.0738 0.796936C21.2738 0.991686 22.307 1.75142 22.8507 2.83879V2.83879C23.5784 4.29507 23.2928 6.05361 22.1417 7.20479L15.7497 13.8748Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIiHandGiveIcon);
export default __webpack_public_path__ + "static/media/loveIiHandGiveIcon.d066c8125f97cf1204d86e63ce057236.svg";
export { ForwardRef as ReactComponent };